var map = {
	"./amazon.svg": 62902,
	"./apple.svg": 84628,
	"./baidu.svg": 2901,
	"./battlenet.svg": 43520,
	"./discord.svg": 30971,
	"./epicgames.svg": 24697,
	"./facebook.svg": 9921,
	"./github.svg": 9429,
	"./google.svg": 25096,
	"./kakao.svg": 66726,
	"./linkedin.svg": 94918,
	"./mailru.svg": 81028,
	"./microsoft.svg": 45415,
	"./msn.svg": 70546,
	"./naver.svg": 59205,
	"./ok.svg": 81102,
	"./paypal.svg": 56329,
	"./qq.svg": 41842,
	"./reddit.svg": 80335,
	"./steam.svg": 99139,
	"./three-dots.svg": 32667,
	"./twitch.svg": 25599,
	"./twitter.svg": 16254,
	"./vimeo.svg": 54080,
	"./vk.svg": 4612,
	"./wechat.svg": 25229,
	"./weibo.svg": 99263,
	"./xbox.svg": 41022,
	"./yahoo.svg": 52804,
	"./yandex.svg": 8033,
	"./youtube.svg": 11477
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78915;